import script from "./LanguageSelectionView.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSelectionView.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSelectionView.vue?vue&type=style&index=0&id=27c0a492&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27c0a492"]])

export default __exports__